export const TeamCreateSceneTranslation = {
  fi: {
    TeamCreateScene: {
      inviteUser: 'Kutsu käyttäjä',
    },
  },
};
